import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Star, CheckCircle2 } from 'lucide-react';

const Container = styled.div`
  max-width: 720px;
  margin: 32px auto;
  padding: 0 16px;
`;

const Card = styled.div`
  background: ${({ theme }) => theme.colors.surface.card};
  border: 1px solid ${({ theme }) => theme.colors.surface.border};
  border-radius: 12px;
  padding: 40px 36px;
  box-shadow: 0 1px 4px rgba(${({ theme }) => theme.colors.shadow.rgb}, 0.06);
  text-align: center;
`;

const IconChip = styled.div`
  width: 64px;
  height: 64px;
  margin: 0 auto 20px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.text.light.very};
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.colors.primary.main},
    ${({ theme }) => theme.colors.secondary.main}
  );
`;

const Title = styled.h2`
  margin: 0 0 8px;
  font-family: ${({ theme }) => theme.metrics.font.family};
  font-size: ${({ theme }) => theme.metrics.font.size.xl};
  color: ${({ theme }) => theme.colors.text.primary};
`;

const Lead = styled.p`
  margin: 0 0 24px;
  color: ${({ theme }) => theme.colors.text.muted};
  font-size: 15px;
  line-height: 1.5;
`;

const FeatureList = styled.ul`
  list-style: none;
  margin: 0 0 28px;
  padding: 0;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Feature = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 15px;

  svg {
    flex-shrink: 0;
    margin-top: 2px;
    color: ${({ theme }) => theme.colors.secondary.main};
  }
`;

const Note = styled.div`
  padding: 14px 16px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.bgColor};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 14px;
  font-weight: 600;
`;

export default function TalentUpsellPage() {
  const { t } = useTranslation();
  const features = ['feature1', 'feature2', 'feature3', 'feature4'];
  return (
    <Container>
      <Card>
        <IconChip><Star size={30} /></IconChip>
        <Title>{t('talent.upsell.title')}</Title>
        <Lead>{t('talent.upsell.lead')}</Lead>
        <FeatureList>
          {features.map((f) => (
            <Feature key={f}>
              <CheckCircle2 size={18} />
              <span>{t(`talent.upsell.${f}`)}</span>
            </Feature>
          ))}
        </FeatureList>
        <Note>{t('talent.upsell.note')}</Note>
      </Card>
    </Container>
  );
}
